module.exports = __webpack_public_path__ + "media/new-message-tone.8e011c65.mp3";